import { render, staticRenderFns } from "./H5Result.vue?vue&type=template&id=4d81606a&"
import script from "./H5Result.vue?vue&type=script&lang=js&"
export * from "./H5Result.vue?vue&type=script&lang=js&"
import style0 from "./H5Result.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d81606a')) {
      api.createRecord('4d81606a', component.options)
    } else {
      api.reload('4d81606a', component.options)
    }
    module.hot.accept("./H5Result.vue?vue&type=template&id=4d81606a&", function () {
      api.rerender('4d81606a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/H5Result.vue"
export default component.exports